module.exports = __webpack_public_path__ + "static/img/banner@2x.0ffd6d4.webp";


//////////////////
// WEBPACK FOOTER
// ./static/webp2/banner@2x.webp
// module id = bOxN
// module chunks = 1